<a href="javascript:;" class="dialog-close" (click)="close()"
><i class="fal fa-times"></i
></a>
<div class="row align-items-end justify-content-between">
  <div class="col-md-4" *ngIf="!isLocked">
    <form style="display:flex"
      nz-form
      nzLayout="vertical"
      [formGroup]="form"
      (submit)="createList()"
    >
      <nz-form-item class="mb-1">
        <nz-form-label nzFor="name" nzRequired>{{
          "listName" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="name" id="name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item  class="mb-2" style="padding-left: 5px;">
        <nz-form-label nzFor="date" nzRequired>{{
          "Lista za Datum" | translate
        }}</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            formControlName="date"
            id="date"
            [nzPlaceHolder]="'date' | translate"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>

  <div class="col-md-3" *ngIf="!id">
    <form (submit)="searchFamilies()">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input
          type="text"
          nz-input
          [formControl]="searchQueryControl"
          [placeholder]="'searchFamilies' | translate"
        />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch>
          <i class="far fa-search"></i>
        </button>
      </ng-template>
    </form>
  </div>
</div>
<span *ngIf="isLocked" style="font-weight: 700; font-size: 16px;">Ova lista je kompletirana!</span>
<nz-table
  class="mt-2"
  [nzData]="data"
  [nzLoading]="isLoading"
  [nzFrontPagination]="false"
  [nzTotal]="tableData.total"
  [nzPageSize]="tableData.pageSize"
  [nzPageIndex]="tableData.page"
  (nzQueryParams)="tableParamsChanged($event)"
>
  <thead>
    <tr>  
      <!-- <th nzWidth="50px">ID</th> -->
      <th>{{ "representative" | translate }}</th>
      <th>{{ "phone" | translate }}</th>
      <th>{{ "address" | translate }}</th>
      <th>{{ "city" | translate }}</th>
      <th>Posljednja Donacija Odjeca</th>
      <th>Dokumenti</th>
      <th nzWidth="60px" *ngIf="!isLocked">{{ "Select" | translate }}</th>
      <th nzWidth="60px" *ngIf="!isLocked">{{ "Note" | translate }}</th>

    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of data">
      <tr>
        <!-- <td>{{ data.id }}</td> -->
        <td>{{ data.representative }}</td>
        <td>{{ data.phone }}</td>
        <td>{{ data.address }}</td>
        <td>{{ data.city }}</td>
        <td>{{ formatDate(data.lastDonationOdjeca?.donationDate) }}</td>
        <td>{{ data.documents ? 'Da' : 'Ne' }}</td>
        <td *ngIf="!isLocked"
        [nzChecked]="setOfCheckedId.has(data.id)"
        (nzCheckedChange)="onItemChecked(data.id, $event)"
      ></td>
      <td class="text-right" *ngIf="!isLocked">
        <button nz-button nzSize="small" (click)="addNote(data.id)">
          <i class="far fa-plus"></i>
        </button>
      </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>

<div class="text-right">
  <button
    nz-button
    [nzType]="'primary'"
    (click)="markReceivedDonation()"
    [disabled]="!form.valid || setOfCheckedId.size === 0|| isLocked"
    [nzLoading]="isSaving"
    *ngIf="id"
  >
    {{ "markReceivedDonation" | translate }} ({{ setOfCheckedId.size }})
  </button>
  <button
    nz-button
    [nzType]="'primary'"
    (click)="createList()"
    [disabled]="!form.valid || setOfCheckedId.size === 0"
    [nzLoading]="isSaving"
    *ngIf="!id"
  >
    {{ "createList" | translate }} ({{ setOfCheckedId.size }})
  </button>
  <button
    nz-button
    (click)="close()"
    type="button"
    class="ml-2"
    [disabled]="isSaving"
  >
    {{ "cancel" | translate }}
  </button>
</div>
